import Swiper from 'swiper/bundle';

let heroOptions = {
    effect: 'fade',
    speed: 900,
    fadeEffect: {
        crossFade: true
    },
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    loop: true,
    slidesPerView: 1,
};

(function ($) {
    let swiper = new Swiper(".slider-hero-8.swiper-container", heroOptions);
})(jQuery);